// src/AddToPure.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import baseURL from './baseUrl';
import logo from './logo.new1.png';

const AddToPure = () => {
  const [amount, setAmount] = useState('');
  const [note, setNote] = useState('');
  const [message, setMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [transaction, setTransaction] = useState(null);
  const [logoBase64, setLogoBase64] = useState(null);

  useEffect(() => {
    const convertLogoToBase64 = async () => {
      try {
        const response = await fetch(logo);
        const blob = await response.blob();
        const reader = new FileReader();
        reader.onloadend = () => {
          setLogoBase64(reader.result);
        };
        reader.readAsDataURL(blob);
      } catch (error) {
        console.error('Error converting logo to base64:', error);
      }
    };
    convertLogoToBase64();
  }, []);

  const handlePrint = () => {
    if (!logoBase64 || !transaction) {
      console.error('Logo or transaction not loaded');
      return;
    }

    const printWindow = document.createElement('iframe');
    document.body.appendChild(printWindow);
  
    const doc = printWindow.contentWindow.document;
    doc.open();
    doc.write('<html><head><title>Print Transaction</title>');
    doc.write('<style>');
    doc.write('body { font-family: Arial, sans-serif; margin: 0; padding: 20px; background-color: #f9f9f9; }');
    doc.write('.container { width: 80%; margin: auto; padding: 20px; background: #fff; border: 1px solid #ccc; border-radius: 8px; }');
    doc.write('h1 { text-align: center; font-size: 14px; margin-bottom: 20px; }');
    doc.write('.header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }');
    doc.write('.logo { width: 70px; height: auto; object-fit: contain; }');
    doc.write('.table { width: 100%; border-collapse: collapse; margin-top: 20px; }');
    doc.write('.table th, .table td { border: 1px solid #000; padding: 8px; text-align: center; }');
    doc.write('.table th { background-color: #f2f2f2; }');
    doc.write('.totals { margin-top: 20px; width: 100%; border-collapse: collapse; }');
    doc.write('.total-row { display: grid; grid-template-columns: 1fr 1fr; border: 1px solid #000; }');
    doc.write('.total-row > span { padding: 8px; border-right: 1px solid #000; }');
    doc.write('.total-row > span:first-child { font-weight: bold; text-align: right; background: #f2f2f2; }');
    doc.write('.total-row > span:last-child { text-align: right; border-right: none; }');
    doc.write('.note { margin-top: 20px; padding: 10px; border: 1px solid #ccc; }');
    doc.write('</style>');
    doc.write('</head><body>');
  
    doc.write('<div class="container">');
    doc.write('<h1>|| SHREE GANESHAY NAMH ||</h1>');
    doc.write('<div class="header">');
    doc.write(`<img src="${logoBase64}" class="logo" alt="Logo">`);
    doc.write(`<span>Date: ${new Date(transaction.date).toLocaleDateString()}</span>`);
    doc.write('</div>');
    
    doc.write('<p><strong>Receipt No:</strong> ' + (transaction.receiptNo || 'N/A') + '</p>');
    
    // Table for Transaction Details
    doc.write('<table class="table">');
    doc.write('<thead>');
    doc.write('<tr><th>Pure Weight Added</th></tr>');
    doc.write('</thead>');
    doc.write('<tbody>');
    doc.write(`<tr><td>${transaction.amount} g</td></tr>`);
    doc.write('</tbody>');
    doc.write('</table>');
    
    // Note Section if exists
    if (transaction.note) {
      doc.write('<div class="note">');
      doc.write('<strong>Note:</strong>');
      doc.write(`<p>${transaction.note}</p>`);
      doc.write('</div>');
    }
    
    doc.write('</div>');
    doc.write('</body></html>');
    doc.close();
    
    printWindow.contentWindow.focus();
    printWindow.contentWindow.print();
    document.body.removeChild(printWindow);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const value = parseFloat(amount);
    if (isNaN(value) || value <= 0) {
      setMessage('Please enter a valid amount greater than zero.');
      return;
    }
    try {
      const response = await axios.post(`${baseURL}/api/transactions/add-to-pure-weight`, {
        amount: value,
        note
      }, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      setTransaction({
        ...response.data,
        date: new Date(),
        amount: value,
        note: note
      });
      
      setMessage('Pure weight updated successfully!');
      setShowModal(true);
      setAmount('');
      setNote('');
    } catch (error) {
      setMessage('Error adding to pure weight. Please try again.');
      console.error(error);
    }
  };

  return (
    <div className="container">
      <h2>Add to Pure Weight</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group mb-3">
          <label htmlFor="amount">Amount:</label>
          <input
            type="number"
            className="form-control"
            id="amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            required
          />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="note">Note:</label>
          <textarea
            className="form-control"
            id="note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            rows="3"
            placeholder="Enter any additional notes here..."
          />
        </div>
        <button type="submit" className="btn btn-primary">Add Pure Weight</button>
      </form>
      {message && <div className="alert alert-info mt-3">{message}</div>}
      
      {/* Receipt Modal */}
      {showModal && transaction && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Transaction Receipt</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <p><strong>Amount Added:</strong> {transaction.amount} g</p>
                {transaction.note && (
                  <p><strong>Note:</strong> {transaction.note}</p>
                )}
                <p><strong>Date:</strong> {new Date(transaction.date).toLocaleDateString()}</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                <button type="button" className="btn btn-primary" onClick={handlePrint}>Print Receipt</button>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* Modal Backdrop */}
      {showModal && <div className="modal-backdrop show"></div>}
    </div>
  );
};

export default AddToPure;
